<template>
  <div class="ui segment">

    Top Preces ...

  </div>
</template>

<script>

export default {

  data () {
    return {
      msg: 'Welcome to Your Vue.js App 2'
    }
  }
}
</script>



// WEBPACK FOOTER //
// TopGoodsPage.vue?148b3492